import { PaymentMethodBankAccountType } from '../enums';

export interface PaymentMethod {
  id: string;
  type: string;
  memberId: string;
  companyId: string;
  status: string;
  acknowledgedAt: string;
  active: boolean;
}

export const PaymentMethodType = {
  PAYPAL: 'paypal',
  BANK_ACCOUNT: 'bank_account',
  PAPER_CHEQUE: 'paper_cheque',
};

export interface PayPalAccount extends PaymentMethod {
  meta: {
    paypalAccountId: string;
  }
}

export interface BankAccount extends PaymentMethod {
  meta: {
    accountNumber: string;
    routingNumber: string;
    city: string;
    country: string;
    postalCode: string;
    addressLine1: string;
    stateProvince: string;
    businessName: string;
    accountType: PaymentMethodBankAccountType;
  }
}

export interface PaperCheque extends PaymentMethod {
  meta: {
    paperChequeToken: string;
    businessName: string;
    addressLine1: string;
    addressLine2?: string;
    city: string;
    country: string;
    stateProvince: string;
    postalCode: string;
  }
}
